import { Redirect, useLocation } from "react-router-dom";
import useAppContext from "../AppContext";
import routes from "../../routes";

export default function RedirectFirstQuestion() {
  const { assessment } = useAppContext();
  const location = useLocation();
  const path = assessment.questions[0].urlPath;

  return (
    <Redirect
      to={{
        pathname: routes.question(path),
        search: location.search
      }}
    />
  );
}
